// extracted by mini-css-extract-plugin
export default {"root":"LandingAssetMarket_root__4HYdy","wrapper":"LandingAssetMarket_wrapper__RYTq8"};